import './WWW.scss';

export default function WWW() {
  return (
    <svg
      className="WWW"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 311.2 268.5"
    >
      <g className="WWW-group">
        <path
          d="M311.2,190h-33c-18.4,46.5-66.4,78.5-122.6,78.5c-56.2,0-104.2-32-122.6-78.5H0V79h32.5C51.4,32,98.9,0,155.6,0
            c56.7,0,104.2,32,123.1,79h32.5V190z M291.8,98.4h-19.4l-9.2,42.2l-10.7-42.2h-15l-10.2,42.2l-10.2-42.2h-33.9l-9.2,42.2
            l-10.7-42.2h-15l-10.2,42.2L128,98.4H94l-9.2,42.2L74.2,98.4h-15L49,140.6L38.8,98.4H19.4l18.4,73.7h18.4l10.2-40.2l9.7,40.2H95
            l16-64l16,64h18.4l10.2-40.2l9.7,40.2h18.9l16-64l16,64h18.4l10.2-40.2l9.7,40.2h18.9L291.8,98.4z M54.3,79h36.8
            c0.5-1,0.5-1.9,1-2.9C81.9,71.7,73.2,66.9,65,60.6C60.6,66.4,57.2,72.2,54.3,79z M65,208c8.2-6.3,17-11.1,27.1-15.5l-1-2.4H54.3
            C57.2,196.3,60.6,202.6,65,208z M78,46.1c4.4,4.4,12.6,10.2,21.3,13.6c7.8-15.5,17.5-29.1,31-41.2C110,23.8,91.6,33,78,46.1z
             M130.4,250.6c-13.6-12.1-23.3-25.7-31-41.2c-8.7,3.4-17,9.2-21.3,13.6C91.6,236.1,110,245.3,130.4,250.6z M115.9,66.4
            c9.2,3.4,22.8,5.8,30.5,5.8v-48C133.3,36.4,123.6,50.4,115.9,66.4z M146.4,196.8c-7.8,0-21.3,2.4-30.5,5.8
            c7.8,16,17.5,30.1,30.5,42.2V196.8z M164.8,72.2c7.8,0,21.3-2.4,30.5-5.8c-7.8-16-17.5-30.1-30.5-42.2V72.2z M195.4,202.6
            c-9.2-3.4-22.8-5.8-30.5-5.8v48C177.9,232.7,187.6,218.6,195.4,202.6z M180.8,18.4c13.6,12.1,23.3,25.7,31,41.2
            c8.7-3.4,17-9.2,21.3-13.6C219.6,33,201.2,23.8,180.8,18.4z M233.2,223c-4.4-4.4-12.6-10.2-21.3-13.6c-7.8,15.5-17.5,29.1-31,41.2
            C201.2,245.3,219.6,236.1,233.2,223z M246.2,60.6c-8.2,6.3-17,11.1-27.1,15.5c0.5,1,0.5,1.9,1,2.9h36.8
            C254,72.2,250.6,66.4,246.2,60.6z M256.9,190h-36.8l-1,2.4c10.2,4.4,18.9,9.2,27.1,15.5C250.6,202.6,254,196.3,256.9,190z"
        />
      </g>
    </svg>
  );
}
